import { useContext, useEffect, useState } from 'react';
import { Collapse, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { RowDetailPanel } from './RowDetailPanel/RowDetailPanel';
import { columns } from './Columns';
import { OrdersContext } from '../../services/Orders';

const MIN_WIDTH = 1200;
function HistoryTable() {
    const { approved } = useContext(OrdersContext);
    const [expandedRowId, setExpandedRowId] = useState<string | null>(null);
    const [columnVisibility, setColumnVisibility] = useState({
        delivery_zone: window.innerWidth >= MIN_WIDTH,
        fullname: window.innerWidth >= MIN_WIDTH,
        referred: window.innerWidth >= MIN_WIDTH,
    });

    useEffect(() => {
        const handleResize = () => {
            setColumnVisibility({
                delivery_zone: window.innerWidth >= MIN_WIDTH,
                fullname: window.innerWidth >= MIN_WIDTH,
                referred: window.innerWidth >= MIN_WIDTH,
            });
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const table = useReactTable({
        data: approved,
        columns,
        getCoreRowModel: getCoreRowModel(),
        state: {
            rowSelection: {},
            columnVisibility,
        },
    });
    return (
        <Table stickyHeader size="small">
            <TableHead>
                {table.getHeaderGroups().map((headerGroup) => (
                    <TableRow key={headerGroup.id}>
                        {headerGroup.headers.map((header) => (
                            <TableCell key={header.id} sx={{ width: header.getSize() }}>
                                {flexRender(header.column.columnDef.header, header.getContext())}
                            </TableCell>
                        ))}
                    </TableRow>
                ))}
            </TableHead>
            <TableBody>
                {table.getRowModel().rows.map((row) => (
                    <>
                        <TableRow
                            key={row.id}
                            hover
                            onClick={() =>
                                setExpandedRowId((prev) =>
                                    prev === row.original.id ? null : row.original.id,
                                )
                            }>
                            {row.getVisibleCells().map((cell) => (
                                <TableCell key={cell.id}>
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </TableCell>
                            ))}
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={table.getVisibleFlatColumns().length} sx={{ p: 0 }}>
                                <Collapse
                                    in={expandedRowId === row.original.id}
                                    timeout="auto"
                                    unmountOnExit>
                                    <RowDetailPanel order={row.original} />
                                </Collapse>
                            </TableCell>
                        </TableRow>
                    </>
                ))}
            </TableBody>
        </Table>
    );
}

export default HistoryTable;
